import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  Select,
} from '@chakra-ui/react';

const AssignRegisterModal = ({
  isOpen,
  onClose,
  tagList,
  currentItem,
  onSave,
  targetField = 'tagInfo', // 🔸 "tagInfo" veya "tagInfo1"
  selectedTagId, // 🔸 Opsiyonel: mevcut tag1Id vs.
  setSelectedTagId, // 🔸 Opsiyonel: dışarıya set etmek istenirse
  title = 'Assign Register', // 🔸 Başlık dinamik olsun
}) => {
  const [selectedDevice, setSelectedDevice] = React.useState('');
  const [selectedTag, setSelectedTag] = React.useState('');

  const currentItemId = currentItem?.id;
  React.useEffect(() => {
    if (!isOpen) return;
    setSelectedDevice(currentItem?.deviceInfo?.id || '');
    setSelectedTag(
      selectedTagId || currentItem?.[targetField]?.registerId || ''
    );
  }, [isOpen, currentItemId, targetField]);

  const handleDeviceChange = e => {
    setSelectedDevice(e.target.value);
    setSelectedTag('');
    if (setSelectedTagId) setSelectedTagId('');
  };

  const handleTagChange = e => {
    setSelectedTag(e.target.value);
    if (setSelectedTagId) setSelectedTagId(e.target.value);
  };

  const handleAssign = () => {
    onSave(selectedDevice, selectedTag);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <label>Device:</label>
          <Select
            placeholder="Select Device"
            value={selectedDevice}
            onChange={handleDeviceChange}
          >
            {tagList
              .filter(device => device.tags?.length > 0)
              .map(device => (
                <option key={device.id} value={device.id}>
                  {device.deviceName}
                </option>
              ))}
          </Select>

          {selectedDevice && (
            <>
              <label>Tag:</label>
              <Select
                placeholder="Select Tag"
                value={selectedTag}
                onChange={handleTagChange}
              >
                {(() => {
                  const device = tagList.find(d => d.id === selectedDevice);
                  if (!device) return null;

                  const specialToolboxIds = ['151', '152', '122'];

                  const isSpecialToolbox =
                    currentItem?.toolboxId &&
                    specialToolboxIds.includes(String(currentItem.toolboxId));

                  // 🔥 Buraya dikkat: değeri gerçekten boolean mu kontrol edelim
                  const filteredTags = device.tags?.filter(tag => {
                    if (!tag) return false;

                    if (isSpecialToolbox) {
                      const v = tag.value;
                      return v === 'true' || v === 'false';
                    }

                    return true;
                  });

                  return filteredTags.map(tag => (
                    <option key={tag.registerId} value={tag.registerId}>
                      {tag.name}
                    </option>
                  ));
                })()}
              </Select>
            </>
          )}

          <Button mt={4} colorScheme="blue" onClick={handleAssign}>
            Assign
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AssignRegisterModal;
